var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1677,
    cy: 20.9691,
    rx: 15.1677,
    ry: 20.9691,
    transform: "matrix(0.949162 0.314789 -0.321409 0.946941 96.2275 19.4745)",
    fill: "#FF9B50"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.045,
    cy: 18.0893,
    rx: 13.045,
    ry: 18.0893,
    transform: "matrix(0.830018 0.557736 -0.56625 0.824234 129.04 49.0294)",
    fill: "#FF9B50"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1677,
    cy: 20.9691,
    rx: 15.1677,
    ry: 20.9691,
    transform: "matrix(-0.950935 0.309392 0.316023 0.948751 69.1514 19.5927)",
    fill: "#FF9B50"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.045,
    cy: 18.0893,
    rx: 13.045,
    ry: 18.0893,
    transform: "matrix(-0.833174 0.553011 0.561558 0.827438 36.1729 48.9606)",
    fill: "#FF9B50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1217 79.272C66.4732 73.0979 74.1949 70 83.2087 70C92.2225 70 99.9443 73.0979 106.296 79.272C112.648 85.4467 115.84 92.9596 115.84 101.735C115.84 111.58 112.424 120.202 105.623 127.538C98.9967 134.687 91.8045 141.246 84.047 147.216C83.5546 147.595 82.8628 147.595 82.3705 147.216C74.613 141.246 67.4208 134.687 60.7944 127.538C53.9934 120.202 50.5771 111.58 50.5771 101.735C50.5771 92.9596 53.7697 85.4466 60.1217 79.272ZM82.755 113.962C92.0163 113.962 99.524 106.454 99.524 97.193C99.524 87.9317 92.0163 80.424 82.755 80.424C73.4937 80.424 65.986 87.9317 65.986 97.193C65.986 106.454 73.4937 113.962 82.755 113.962Z",
    fill: "#FF9B50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap1);
export default __webpack_public_path__ + "static/media/발바닥_map-1.2dddb05c9347643562e47127ddfd8305.svg";
export { ForwardRef as ReactComponent };